/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/KeyboardArrowLeft';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const KeyboardArrowLeftIcon = withMuiAdapter(Base, 'KeyboardArrowLeft');
